/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * Use this only for fixing bug 2099708, and not implement.
 * Should share codes with Chrome Client after implementing
 * 2 storageService for HTML and Chrome client.
 */

import { BrokerSettingService } from "../../shared/launcher/common/broker-setting.service";
import { Injectable } from "@angular/core";

@Injectable()
export class BrokerSettingHTML5Service extends BrokerSettingService {
   constructor() {
      super();
   }

   public setLastADConnectionInfo = (brokerAddress, userName, domain) => {
      return new Promise((resolve, reject) => {
         // @ts-ignore
         resolve();
      });
   };

   public getLastADConnectionInfo = (brokerAddress) => {
      return new Promise((resolve, reject) => {
         resolve({});
      });
   };
}
